
import { takeEvery } from 'redux-saga/effects'

import {
    createActionTypes,
} from '../common';

import { workGetPermissions } from './permissions';

export const GET_USER_PERMISSIONS_ACTION_TYPE = createActionTypes('permissions/GET_USER_PERMISSIONS');

export default function getActions(dispatch) {
    return {
        getUserPermissions: (token, projectId) => dispatch({
            type: GET_USER_PERMISSIONS_ACTION_TYPE.DEFAULT,
            token, projectId,
        }),
    };
}

export function* watchGetUserPermissions(options) {
    yield takeEvery(
        GET_USER_PERMISSIONS_ACTION_TYPE.DEFAULT, workGetPermissions, options, GET_USER_PERMISSIONS_ACTION_TYPE
    );
}
